export default __webpack_public_path__ + "static/media/2nd.5aa36d6f.png";